var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolatilityIncreasing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.524 6.25a1.25 1.25 0 011.254.997l3.446 16.667a1.25 1.25 0 11-2.448.506l-2.056-9.943-2.87 18.217a1.25 1.25 0 01-2.462.045l-3.003-15.435-3.44 10.813a1.25 1.25 0 01-2.364.052l-3.02-8.212-2.11 3.645a1.25 1.25 0 01-1.406.581l-3.916-1.052-3.482 2.105a1.25 1.25 0 01-1.294-2.139l3.939-2.381a1.25 1.25 0 01.97-.138l3.506.942 2.965-5.122a1.25 1.25 0 012.256.195l2.68 7.29 3.817-12a1.25 1.25 0 012.418.14l2.582 13.267 2.833-17.985a1.25 1.25 0 011.205-1.055z"
  })));
}
export default SvgVolatilityIncreasing;